// extracted by mini-css-extract-plugin
module.exports = {"loader":"SpinnerLoader_loader__O-qaS","spin":"SpinnerLoader_spin__uWNeA"};